if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super()
      this.initObserver()
    }

    initObserver() {
      const loadRecommendations = (entries, observer) => {
        if (!entries[0].isIntersecting) return
        observer.unobserve(this)

        const url = this.dataset.url
        if (!url) return

        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div')
            html.innerHTML = text
            const recommendations = html.querySelector(`product-recommendations[id=${this.id}]`)
            const hasCards =
              recommendations && recommendations.querySelector('.product-card, .mini-product-card:not(.skeleton)')

            if (hasCards) {
              this.innerHTML = recommendations.innerHTML
              this.sliderButtonsPosition()
            } else {
              this.innerHTML = ''
              this.classList.add('hidden')
            }
          })
          .catch((e) => {
            console.error(e)
          })
      }

      const intersectionObserver = new IntersectionObserver(loadRecommendations, {
        rootMargin: '0px 0px 500px 0px',
      })
      intersectionObserver.observe(this)
    }

    sliderButtonsPosition() {
      const layoutSlider = this.querySelector('.layout-slider')
      if (!layoutSlider) return
      const productCardMedia = layoutSlider.querySelector('.product-card__media:not(.product-card__media--auto)')
      if (!productCardMedia) return

      if (typeof layoutSlider.customButtonsPosition === 'function') {
        layoutSlider.customButtonsPosition(productCardMedia)
      }
    }
  }

  customElements.define('product-recommendations', ProductRecommendations)
}
